// @flow
import React from 'react';
import {
  compose,
  defaultProps,
  mapProps,
  setDisplayName,
} from 'recompose';
import reactCSS from 'reactcss';
import Transition from 'react-inline-transition-group';
import SearchForm, {
  Design as SearchFormDesign,
} from './Form';
import { getStyles } from '@ux/style-utils';
import { gu2px } from '@ux/theme-utils';
import cssSides, { Side } from '@team-griffin/css-sides';
// $FlowFixMe
import color from 'color';
import * as r from 'ramda';
import { nuller, ifElseBool } from '../../../crosscutting/capra';
import { Container, Row, Column } from '@ux/grid';

export const defaultOffset = -(100);

export const stylesheet = ({
  theme,
  offset,
}) => {
  const shadowColor = color(theme.palette.grey06)
    .alpha(0.5)
    .string();

  const stickyOffset = defaultOffset - offset;

  /* eslint-disable no-underscore-dangle */
  const speed = r.cond([
    [ r.gte(r.__, 500), r.always(500) ],
    [ r.gte(r.__, 250), r.always(400) ],
    [ r.T, r.always(300) ],
  ])(offset);
  /* eslint-enable no-underscore-dangle */

  return {
    default: {
      root: {
        ...cssSides('padding', Side.Y, gu2px(2, theme.spacing)),
        backgroundColor: '#fff',
        marginBottom: gu2px(1, theme.spacing),
        boxShadow: `5px 0 10px ${shadowColor}`,
      },
      inner: {
        display: 'flex',
        flexDirection: 'column',
      },
      base: {
        position: 'fixed',
        zIndex: 999, // want to make sure its above anything from brand
        top: offset,
        marginTop: stickyOffset,
        left: 0,
        right: 0,
        transition: `margin-top ${speed}ms ease-in-out`,
      },
      enter: {
        marginTop: 0,
        transition: `margin-top ${speed}ms ease-in-out`,
      },
      leave: {
        marginTop: stickyOffset,
        transition: `margin-top ${speed}ms ease-in-out`,
      },
      buttonText: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        justifyContent: 'center',
      },
    },

    isMinSm: {
      inner: {
        flexDirection: 'row',
      },
      base: {
        marginTop: stickyOffset,
      },
    },
  };
};

// eslint-disable-next-line no-shadow
export const stylesheetToStyles = (stylesheet, props) => reactCSS(stylesheet, {
  isMinSm: props.isMinSm,
}, props);

export const PureStickySearch = ({
  theme,
  styles,
  isMinSm,
  isMinMd,
  initialValues,
  sticky,
  // Events
  onChange,
  onSubmit,
}) => (
  <Transition
    childrenStyles={{
      base: styles.base,
      enter: styles.enter,
      leave: styles.leave,
    }}
  >
    {ifElseBool(
      r.always(
        <div style={styles.root}>
          <Container theme={theme}>
            <Row theme={theme}>
              <Column
                theme={theme}
                xs={12}
              >
                <div style={styles.inner}>
                  <SearchForm
                    theme={theme}
                    isMinSm={isMinSm}
                    isMinMd={isMinMd}
                    onSubmit={onSubmit}
                    onChange={onChange}
                    initialValues={initialValues}
                    design={SearchFormDesign.STICKY}
                  />
                </div>
              </Column>
            </Row>
          </Container>
        </div>
      ),
      nuller,
    )(sticky)}
  </Transition>
);

export const enhance = compose(
  setDisplayName('StickySearch'),
  defaultProps({
    offset: 0,
  }),
  mapProps(r.pipe(
    r.when(
      r.propIs(Function, 'offset'),
      (props) => r.assoc('offset', props.offset(), props),
    ),
    (props) => ({
      ...props,
      styles: getStyles(stylesheet, stylesheetToStyles, props),
    }),
  )),
);

export default enhance(PureStickySearch);
